import React, { Component, PropTypes } from "react";
import { Link } from "react-router";
import styled from "styled-components";

import {
  NitroGrid,
  NitroHeading,
  NitroIcon,
  NitroPanel
} from "nitro-components";

import ButtonIcognito from "../../../components/common/ButtonIcognito";

const CardHeaderRight = component => styled(component)`
  color: ${props => props.theme.color.base2};
  transition: color .3s;

  &:hover {
      color: ${props => props.theme.color.base1};
  }
`;

const CardHeader = styled.header`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const CardHeaderLink = styled.span`
  font-size: ${props => props.theme.size[5]}px;
  font-weight: bold;
  letter-spacing: 1px;
  margin: 0 0 0 auto;
  text-transform: uppercase;
  ${props => (props.iconPosition === "right" ? "margin-right" : "margin-left")}: 5px;
`;

const CardPanel = styled(NitroPanel)`
  display: ${props => props.display};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${props => props.height};
  padding: ${props => props.padding}px;
`;

class CardWithHeader extends Component {
  renderHeader() {
    const { headerLeft, headerRight } = this.props;

    const headerRightIcon =
      headerRight &&
      headerRight.icon &&
      <NitroIcon currentColor name={headerRight.icon} size={10} />;

    const headerRightIsLink = headerRight && headerRight.action === "string";
    const HeaderRightComponent = headerRightIsLink
      ? CardHeaderRight(Link)
      : CardHeaderRight(ButtonIcognito);

    const headerRightContent =
      headerRight &&
      headerRight.label &&
      <HeaderRightComponent
        onClick={headerRightIsLink ? null : headerRight.action}
      >
        {headerRight.iconPosition === "left" && headerRightIcon}
        <CardHeaderLink iconPosition={headerRight.iconPosition}>
          {headerRight.label}
        </CardHeaderLink>
        {headerRight.iconPosition === "right" && headerRightIcon}
      </HeaderRightComponent>;

    return (
      <CardHeader>
        {headerLeft &&
          <NitroHeading inline noMargin label={headerLeft} size="3" />}
        {headerRightContent}
      </CardHeader>
    );
  }

  render() {
    const {
      children,
      grid,
      noPadding,
      panelHeight,
      transition,
      transitionDelay,
      transitionDuration,
      contentPadding,
      contentDisplayType
    } = this.props;

    return (
      <NitroGrid
        grid={grid}
        noPadding={noPadding}
        transition={transition}
        transitionDuration={transitionDuration}
        transitionDelay={transitionDelay}
      >
        {this.renderHeader()}
        <CardPanel
          height={panelHeight}
          padding={contentPadding}
          display={contentDisplayType}
        >
          {children}
        </CardPanel>
      </NitroGrid>
    );
  }
}

CardWithHeader.propTypes = {
  children: PropTypes.node,
  grid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  headerLeft: PropTypes.string,
  headerRight: PropTypes.shape({
    label: PropTypes.string,
    action: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    icon: PropTypes.string,
    iconPosition: PropTypes.oneOf(["left", "right"])
  }),
  noPadding: PropTypes.bool,
  panelHeight: PropTypes.string,
  transition: PropTypes.bool,
  transitionDelay: PropTypes.number,
  transitionDuration: PropTypes.number,
  contentDisplayType: PropTypes.string,
  contentPadding: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

CardWithHeader.defaultProps = {
  grid: "2",
  headerRight: {},
  panelHeight: "auto",
  contentDisplayType: "flex",
  contentPadding: '0'
};

export default CardWithHeader;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/CardWithHeader.js